/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.174.0-v202608150118-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqPluginsApiClass {
 
   constructor() {}

  /**
   * @summary Delete a plugin
   * @param {string} id - The ID of the plugin
  */
  public deletePlugin(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/plugins/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get a plugin file
   * @param {string} id - The ID of the plugin
   * @param {string} fileName - The name of the file from the plugin
  */
  public getFile(
    {
      id,
      fileName
    } : {
      id: string,
      fileName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (fileName === null || fileName === undefined) {
      throw new Error("'fileName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/plugins/${encodeURIComponent(String(id))}/files/${encodeURIComponent(String(fileName))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{fileName}', encodeURIComponent(String(fileName)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Get a collection of plugins
   * @param {string} [nameSearch] - Search text by which to filter plugins&#x27; names.
   * @param {string} [identifierSearch] - Search text by which to filter plugins&#x27; identifiers.
   * @param {string} [categorySearch] - Search text by which to filter plugins&#x27; categories.
   * @param {string} [sortOrder=name asc] - A field by which to order the plugins followed by a space and &#x27;asc&#x27; or &#x27;desc&#x27;. Field name can be one of: name, identifier, category
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [includeArchived=false] - Whether archived plugins should be included
  */
  public getPlugins(
    {
      nameSearch,
      identifierSearch,
      categorySearch,
      sortOrder,
      offset,
      limit,
      includeArchived
    } : {
      nameSearch?: string,
      identifierSearch?: string,
      categorySearch?: string,
      sortOrder?: string,
      offset?: number,
      limit?: number,
      includeArchived?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/plugins`;

    const queryParams = {
      ['nameSearch']: nameSearch,      ['identifierSearch']: identifierSearch,      ['categorySearch']: categorySearch,      ['sortOrder']: sortOrder,      ['offset']: offset,      ['limit']: limit,      ['includeArchived']: includeArchived
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.PluginOutputListV1>;
  }

  /**
   * @summary Upload a plugin
   * @param {Blob} [file]
   * @param {boolean} [inDevelopment=false] - Whether this item is in Development Mode, meaning that it is not allowed to be shared with any other users. Non-administrators may only install Plugins in Development Mode.
  */
  public uploadPlugin(
    {
      file,
      inDevelopment
    } : {
      file?: File,
      inDevelopment?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/plugins`;

    const queryParams = {
      ['inDevelopment']: inDevelopment
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );

    const formData = new FormData();
    formData.append('file', file as File, file?.name);

    return axiosInstance.request({
      method: 'post',
      url,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;

    return axiosInstance.request({
      method: 'post',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

}


export const sqPluginsApi = new sqPluginsApiClass();

export type sqPluginsApiEndpoints = {
  'deletePlugin': {
    method: 'delete';
    path: '/plugins/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'getFile': {
    method: 'get';
    path: '/plugins/${encodeURIComponent(String(id))}/files/${encodeURIComponent(String(fileName))}';
    response: string;
  };
  'getPlugins': {
    method: 'get';
    path: '/plugins';
    response: models.PluginOutputListV1;
  };
  'uploadPlugin': {
    method: 'post';
    path: '/plugins';
    response: models.StatusMessageBase;
  };
};

type ApiDeletePluginResponse = models.StatusMessageBase;
type ApideletePluginMutationParams = Parameters<typeof sqPluginsApi.deletePlugin> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqPluginsApi.deletePlugin>;

export function useApiDeletePluginMutation(
  options?: Omit<UseMutationOptions<ApiDeletePluginResponse, AxiosError<SeeqErrorData>,
    ApideletePluginMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeletePluginResponse, AxiosError<SeeqErrorData>,
  ApideletePluginMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideletePluginMutationParams) =>
      sqPluginsApi.deletePlugin(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetFileResponse = string;
export function GetFileQueryKey(
  params: Parameters<typeof sqPluginsApi.getFile>[0],
) {
  return ['sqPluginsApi', 'getFile', params] as const;
}

export function useApiGetFileQuery(
  params: Parameters<typeof sqPluginsApi.getFile>[0],
  options?: Omit<UseQueryOptions<ApiGetFileResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetFileResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetFileQueryKey(params),
    queryFn: () =>
      sqPluginsApi.getFile(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetPluginsResponse = models.PluginOutputListV1;
export function GetPluginsQueryKey(
  params: Parameters<typeof sqPluginsApi.getPlugins>[0],
) {
  return ['sqPluginsApi', 'getPlugins', params] as const;
}

export function useApiGetPluginsQuery(
  params: Parameters<typeof sqPluginsApi.getPlugins>[0],
  options?: Omit<UseQueryOptions<ApiGetPluginsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetPluginsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetPluginsQueryKey(params),
    queryFn: () =>
      sqPluginsApi.getPlugins(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUploadPluginResponse = models.StatusMessageBase;
type ApiuploadPluginMutationParams = Parameters<typeof sqPluginsApi.uploadPlugin> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqPluginsApi.uploadPlugin>;

export function useApiUploadPluginMutation(
  options?: Omit<UseMutationOptions<ApiUploadPluginResponse, AxiosError<SeeqErrorData>,
    ApiuploadPluginMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUploadPluginResponse, AxiosError<SeeqErrorData>,
  ApiuploadPluginMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiuploadPluginMutationParams) =>
      sqPluginsApi.uploadPlugin(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
